export const environment = {
  production: true,
  matomoApplicationId: 13,
};
